import axios from 'axios';

const api = axios.create({
    // baseURL: 'http://localhost:8088/qh-billingadmin-api',
    baseURL: 'https://billing.qrhub.uz/qh-billingadmin-api',
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const login = (phone, password) =>
    api.post('/auth/signin', { phone, password });

export const getData = (endpoint, params) =>
    api.get(endpoint, { params });

export const createData = (endpoint, data) =>
    api.post(endpoint, data);

export const updateData = (endpoint, id, data) =>
    api.put(`${endpoint}/${id}`, data);

export const deleteData = (endpoint, id) =>
    api.delete(`${endpoint}/${id}`);

// Download Excel file
export const downloadExcel = async (endpoint, params = {}, fileName = 'download.xlsx') => {
    try {
        const response = await api.get(endpoint, {
            params,
            responseType: 'blob', // Blob sifatida javob olish
        });

        // Fayl nomini Content-Disposition sarlavhasidan olish (agar mavjud bo'lsa)
        let finalFileName = fileName;
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch && fileNameMatch[1]) {
                finalFileName = fileNameMatch[1];
            }
        }

        // Blob dan fayl yaratish
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        // Dinamik <a> tegi orqali faylni yuklash
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', finalFileName);
        document.body.appendChild(link);
        link.click();

        // Resurslarni tozalash
        link.remove();
        window.URL.revokeObjectURL(url);

        return { success: true, fileName: finalFileName };
    } catch (error) {
        console.error('Excel faylni yuklashda xato:', error);
        throw new Error('Excel faylni yuklashda xato yuz berdi: ' + error.message);
    }
};
export default api;